import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { PutResponseBody } from '../types/api-response';

import { AccountClassification, EntityTaxRate, XeroReportTaxTypeEnum } from '../types/entity';
import queryClient from '../query-client';

export type UpdateEntityTaxRatesRequest = {
    id?: string;
    fields?: { name?: string; rate?: number; type?: AccountClassification[]; xeroReportTaxType?: XeroReportTaxTypeEnum };
}[];

async function updateEntityTaxRates(entityId: string, req: UpdateEntityTaxRatesRequest): Promise<PutResponseBody<EntityTaxRate[]>> {
    const { data } = await api.put(`/entities/${entityId}/tax-rates`, req);
    return data;
}

export function useUpdateEntityTaxRates(
    entityId: string
): UseMutationResult<PutResponseBody<EntityTaxRate[]>, AxiosError, UpdateEntityTaxRatesRequest, unknown> {
    return useMutation((req) => updateEntityTaxRates(entityId, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['entities', entityId, 'tax-rates']);
        },
    });
}
